up.compiler('.select-all', (element) => {
  element.addEventListener('click', (event) => {

    const targetSelector = element.getAttribute('target');
    const target = document.querySelector(targetSelector);
    if (target) {
      const checkboxes = target.querySelectorAll('input[type="checkbox"]');
      
      var newStatus = true;
      if (element.classList.contains('unselect')) {
        newStatus = false;
      }

      checkboxes.forEach((checkbox) => {
        checkbox.checked = newStatus;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      });

      if (newStatus) {
        element.classList.add('unselect');
      } else {
        element.classList.remove('unselect');
      }

      const newContent = element.getAttribute('data-switch-content');
      element.setAttribute('data-switch-content', element.innerHTML);
      element.innerHTML = newContent;

    }
  });
});
